import { AfterViewInit, Directive, ElementRef } from "@angular/core";

@Directive({
  selector: "[biAutofocus]"
})
export class BiAutofocusDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}
  ngAfterViewInit() {
    this.el.nativeElement.focus();
  }
}
